<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Exportar - Dropbox</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="header_search header_search_mobile">
            <div class="title-page"></div>
            <div class="content_search">
              <div class="new-project">
                <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
              </div>
            </div>
          </div>
          <div class="system-table table-container">
            <div class="system-table-conteiner">
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Caminho Dropbox</th>
                    <th>Tipo arquivo</th>
                    <th>Modo envio</th>
                    <th class="text-center btn-icon-td">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of exportarList">
                    <td class="title">{{ item?.id }}</td>
                    <td>{{ item?.type }}</td>
                    <td>{{ item?.fullpath }}</td>
                    <td>{{ item?.execution }}</td>
                    <td>
                      <div class="btn-icon">
                        <a class="icon-table" [routerLink]="editar(item?.id)">
                          <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                        </a>
                        <span class="icon-table" (click)="confirmExcluir(item?.id)">
                          <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="!exportarList?.length" class="border-b-radius">
                    <td colspan="5" class="text-center">Nenhum Registro Cadastrado.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>